<template>
  <div>
    <Snackbar :SnackbarComponent="SnackbarComponent" />
    <!-- <v-card class="CardColor" color="#fd0000">
      <v-row no-gutters>
        <v-col cols="12" md="7">
          <div class="container">
            <div class="wave-container">
              <div class="wave-content">
                <div class="LoginLeftSideClass">
                <div class="CardContent">
                  <v-img max-height="100px" src="@/assets/logo.png" />
                  <div class="text-center text-black FontFamilyVariant1 mt-4">
                    AI Platform to Monitor Heart Health For Everyone!
                  </div>
                  <div class="text-center text-black FontFamilyVariant1 mt-4">
                    Living Your Best Life.
                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="5">
          <v-row
            align="center"
            justify="center"
            :style="{ height: `${cardHeight - 100}px` }"
          >
            <v-col cols="12" class="px-10">
              <div class="FontFamilyVariant2 mx-10">Log In</div>
              <v-form ref="autoFocusOtpField" class="pt-8">
                <div class="FontFamilyVariant3 mx-10">Email Address</div>
                <v-text-field
                  variant="outlined"
                  density="compact"
                  append-inner-icon="mdi-at"
                  placeholder="Enter your email"
                  class="mx-10 mt-2"
                  :rules="[
                    (v) => !!v || 'required',
                    (v) => /.+@.+\..+/.test(v) || 'Email must be Valid',
                    (v) => !!v || 'required',
                  ]"
                  v-model="Login.email_id"
                  @keydown.enter="
                    signInMethod(IsOTPEnabled ? 'VERIFY_OTP' : 'SEND_OTP')
                  "
                ></v-text-field>
                <div
                  v-if="IsOTPEnabled == true"
                  class="mx-10 mt-2 text-left FontSize12px font-weight-bold"
                >
                  You will receive an OTP in registered email for verification.
                </div>
                <v-otp-input
                  v-if="IsOTPEnabled == true"
                  class="OTPField mx-8"
                  v-model="Login.otp"
                ></v-otp-input>
              </v-form>
              <v-card-actions class="mt-5">
                <v-btn
                  class="mx-10"
                  variant="flat"
                  color="primary"
                  :loading="loginLoader"
                  @click="
                    signInMethod(IsOTPEnabled ? 'VERIFY_OTP' : 'SEND_OTP')
                  "
                  >{{ IsOTPEnabled ? "Verify OTP" : "Login" }}</v-btn
                >
              </v-card-actions>
            </v-col>
          </v-row>
        </v-col>
      </v-row> -->

    <!-- <v-row no-gutters>
      <v-col cols="12" md="7">
        <div class="LoginLeftSideClass">
          <div class="CardContent">
            <v-img max-height="100px" src="@/assets/logo.png" />
            <div class="text-center text-white FontFamilyVariant1 mt-4">
              AI Platform to Monitor Heart Health For Everyone!
            </div>
            <div class="text-center text-white FontFamilyVariant1 mt-4">
              Living Your Best Life.
            </div>
          </div>
        </div>
      </v-col>
      <v-col cols="12" md="5">
        <v-row
          align="center"
          justify="center"
          :style="{ height: `${cardHeight - 100}px` }"
        >
          <v-col cols="12" class="px-10">
            <div class="FontFamilyVariant2 mx-10">Log In</div>
            <v-form ref="autoFocusOtpField" class="pt-8">
              <div class="FontFamilyVariant3 mx-10">Email Address</div>
              <v-text-field
                variant="outlined"
                density="compact"
                append-inner-icon="mdi-at"
                placeholder="Enter your email"
                class="mx-10 mt-2"
                :rules="[
                  (v) => !!v || 'required',
                  (v) => /.+@.+\..+/.test(v) || 'Email must be Valid',
                  (v) => !!v || 'required',
                ]"
                v-model="Login.email_id"
                @keydown.enter="
                  signInMethod(IsOTPEnabled ? 'VERIFY_OTP' : 'SEND_OTP')
                "
              ></v-text-field>
              <div
                v-if="IsOTPEnabled == true"
                class="mx-10 mt-2 text-left FontSize12px font-weight-bold"
              >
                You will receive an OTP in registered email for verification.
              </div>
              <v-otp-input
                v-if="IsOTPEnabled == true"
                class="OTPField mx-8"
                v-model="Login.otp"
              ></v-otp-input>
            </v-form>
            <v-card-actions class="mt-5">
              <v-btn
                class="mx-10"
                variant="flat"
                color="primary"
                :loading="loginLoader"
                @click="signInMethod(IsOTPEnabled ? 'VERIFY_OTP' : 'SEND_OTP')"
                >{{ IsOTPEnabled ? "Verify OTP" : "Login" }}</v-btn
              >
            </v-card-actions>
          </v-col>
        </v-row>
      </v-col>
    </v-row> -->

    <v-card class="containerColor">
      <v-card class="my-16 CardColor elevation-0">
        <v-row justify="center" align="center" no-gutters class="mt-3">
          <v-col cols="12" md="9" xs="12" sm="12" align="center">
            <v-card class="CardStyless mt-12 mb-2 mx-2">
              <v-row no-gutters>
                <v-col cols="12" md="7" v-if="$vuetify.display.mdAndUp">
                  <v-img
                    width="500px"
                    height="350px"
                    src="@/assets/AnimatedDoc.png"
                    class="mt-2"
                  >
                    <!-- ImgTransition  -->
                  </v-img>
                  <div class="text-center text-black FontFamilyVariant1 mt-5">
                    AI Platform to Monitor Heart Health For Everyone!
                  </div>
                  <div class="text-center text-black FontFamilyVariant1 mb-3">
                    Living Your Best Life.
                  </div>
                  <!-- <div class="LoginLeftSideClass">
                      <div class="CardContent">
                        <v-img max-height="100px" src="@/assets/logo.png" />
                        <div
                          class="text-center text-white FontFamilyVariant1 mt-4"
                        >
                          AI Platform to Monitor Heart Health For Everyone!
                        </div>
                        <div
                          class="text-center text-white FontFamilyVariant1 mt-4"
                        >
                          Living Your Best Life.
                        </div>
                      </div>
                    </div> -->
                </v-col>
                <v-col
                  cols="12"
                  md="5"
                  align="center"
                  style="background-color: white"
                  class=""
                >
                  <v-card color="white" class="elevation-0" tile>
                    <v-img
                      max-width="250px"
                      src="@/assets/logo.png"
                      class="mt-3"
                    ></v-img>
                    <v-row align="center" justify="center">
                      <v-col cols="12" class="px-10">
                        <div class="FontFamilyVariant2 mx-10 mt-6">Log In</div>
                        <v-form ref="autoFocusOtpField" class="pt-8">
                          <div
                            class="FontFamilyVariant3"
                            align="left"
                            :class="$vuetify.display.mdAndUp ? 'mx-10' : ''"
                          >
                            Email Address
                          </div>
                          <v-text-field
                            variant="outlined"
                            density="compact"
                            append-inner-icon="mdi-email"
                            placeholder="Enter your email"
                            class="mt-2"
                            :class="$vuetify.display.mdAndUp ? 'mx-10' : ''"
                            :rules="[
                              (v) => !!v || '',
                              (v) =>
                                /.+@.+\..+/.test(v) || 'Email must be Valid',
                              (v) => !!v || '',
                            ]"
                            v-model="Login.email_id"
                            @keydown.enter.prevent="
                              signInMethod(
                                IsOTPEnabled ? 'VERIFY_OTP' : 'SEND_OTP'
                              )
                            "
                            :readonly="IsOTPEnabled == true"
                          ></v-text-field>
                          <div
                            v-if="IsOTPEnabled == true"
                            class="mt-2 text-left FontSize12px font-weight-bold"
                            :class="$vuetify.display.mdAndUp ? 'mx-10' : ''"
                          >
                            Enter the OTP sent to your email
                          </div>
                          <v-otp-input
                            v-if="IsOTPEnabled == true"
                            class="OTPField"
                            :length="6"
                            v-model="Login.otp"
                            @keydown.enter="signInMethod('VERIFY_OTP')"
                          ></v-otp-input>
                        </v-form>
                        <v-row>
                          <v-col cols="12" md="6" xs="12" sm="12">
                            <v-btn
                              v-if="IsOTPEnabled == true"
                              size="x-small"
                              variant="outlined"
                              @click.stop="changeEmailID()"
                              >Change Email</v-btn
                            >
                          </v-col>
                          <v-col cols="12" md="6" xs="12" sm="12">
                            <div
                              v-if="ResendOTPValue && IsOTPEnabled == true"
                              class="FontSize14px mr-8 font-weight-bold"
                              align="right"
                            >
                              Resend OTP in {{ countdown }}s
                            </div>
                            <div align="right" class="mr-16">
                              <v-btn
                                color="black"
                                variant="outlined"
                                size="x-small"
                                v-if="showResendButton"
                                @click="resendOTP()"
                              >
                                <span class="text-blue text-capitalize">
                                  Resend OTP
                                </span>
                              </v-btn>
                            </div>
                          </v-col>
                        </v-row>
                        <v-card-actions class="mt-5">
                          <v-spacer />
                          <v-btn
                            class="mx-10 mb-3"
                            variant="flat"
                            color="primary"
                            :loading="loginLoader"
                            @click="
                              signInMethod(
                                IsOTPEnabled ? 'VERIFY_OTP' : 'SEND_OTP'
                              )
                            "
                            >{{ IsOTPEnabled ? "Verify OTP" : "Login" }}</v-btn
                          >
                          <v-spacer />
                        </v-card-actions>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col> </v-row
            ></v-card>
          </v-col>
        </v-row>
      </v-card>
    </v-card>
  </div>
</template>

<script>
import { useDisplay } from "vuetify";
import { signIn, confirmSignIn, signOut } from "aws-amplify/auth";
import Snackbar from "@/components/Extras/Snackbar.vue";
export default {
  components: { Snackbar },
  data: () => ({
    cardHeight: 0,
    Login: {
      email_id: "",
      otp: "",
    },
    SnackbarComponent: {},
    IsOTPFieldEnabled: false,
    loginLoader: false,
    IsOTPEnabled: false,
    countdown: 30,
    timer: null,
    ResendOTPValue: false,
    showResendButton: false,
  }),
  beforeUnmount() {
    clearInterval(this.timer); // Clean up the timer when component unmounts
  },
  mounted() {
    const display = useDisplay();
    this.cardHeight = display.height._object.height;
  },
  methods: {
    async validateMethod() {
      const { valid } = await this.$refs.autoFocusOtpField.validate();
      if (valid) {
        this.signInMethod(this.IsOTPEnabled ? "VERIFY_OTP" : "SEND_OTP");
      } else if (this.Login.email_id == "" && this.IsOTPEnabled == false) {
        this.SnackbarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          timeout: 2000,
          SnackbarText: `Enter valid EmailId`,
        };
      } else if (this.Login.otp == "" && this.IsOTPEnabled) {
        this.SnackbarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "red",
          timeout: 2000,
          SnackbarText: `Enter OTP`,
        };
      }
    },
    async signInMethod(action) {
      console.log("iiiiiisss", this.IsOTPEnabled);
      switch (action) {
        case "SEND_OTP":
          try {
            this.loginLoader = true;
            this.user = await signIn({
              username: this.Login.email_id.toLocaleLowerCase(),
              options: {
                authFlowType: "CUSTOM_WITHOUT_SRP",
              },
            });
            if (
              this.user.nextStep.signInStep ==
              "CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE"
            ) {
              this.SnackbarComponent = {
                SnackbarVmodel: true,
                SnackbarColor: "green",
                timeout: 2000,
                SnackbarText: `Verification OTP sent to ${this.Login.email_id.toLocaleLowerCase()}`,
              };

              this.counter = 60;

              // this.$refs.autoFocusOtpField.reset();
              setTimeout(() => {
                this.IsOTPEnabled = true;
                this.loginLoader = false;
                // setTimeout(() => {
                //   this.$refs.autoFocusOtpField.focus();
                // }, 100);
                this.startCountdown();
              }, 1000);

              this.$forceUpdate();
              // this.startCounter();
            }
          } catch (error) {
            console.log("erro", error);
            if (error.message == "There is already a signed in user.") {
              this.loginLoader = true;
              await signOut({ global: true });
              this.signInMethod("SEND_OTP");
            } else if (
              error.message ==
              "VerifyAuthChallengeResponse failed with error Incorrect OTP!!."
            ) {
              this.IsOTPEnabled = false;
              this.loginLoader = false;
              this.SnackbarComponent = {
                SnackbarVmodel: true,
                SnackbarColor: "redColorVariant3",
                timeout: 2000,
                SnackbarText: error.message,
              };
            } else {
              this.loginLoader = false;
              this.SnackbarComponent = {
                SnackbarVmodel: true,
                SnackbarColor: "redColorVariant3",
                timeout: 2000,
                SnackbarText: error.message,
              };
            }

            // this.SnackbarComponent = {
            //   SnackbarVmodel: true,
            //   SnackbarColor: "red",
            //   SnackbarText: error.message,
            // };

            // console.log("Err", error.message);
          }
          break;
        case "VERIFY_OTP":
          try {
            this.loginLoader = true;
            console.log("coming In");
            await confirmSignIn({ challengeResponse: this.Login.otp })
              .then((res) => {
                this.SnackbarComponent = {
                  SnackbarVmodel: true,
                  SnackbarColor: "green",
                  SnackbarText: "Login Successfull",
                };
                console.log("yes");
                this.IsOTPFieldEnabled = false;
                this.IsSessionLoggedOut = false;
                localStorage.setItem("IsLoggedOut", "false");
                this.loginLoader = false;
                this.ActivateMethod();
              })
              .catch((err) => {
                if (err) {
                  this.counter = 0;
                  this.Login.otp = "";
                  this.IsOTPEnabled = false;
                }
                if (
                  err.message ==
                  "VerifyAuthChallengeResponse failed with error Incorrect OTP!!."
                ) {
                  this.SnackbarComponent = {
                    SnackbarVmodel: true,
                    SnackbarColor: "red",
                    SnackbarText: "Incorrect OTP",
                  };
                } else {
                  this.SnackbarComponent.SnackbarVmodel = false;
                  this.SnackbarComponent = {
                    SnackbarVmodel: true,
                    SnackbarColor: "red",
                    SnackbarText: err.message,
                  };
                }
                this.OTPErrorMessage = err.message;
                this.loginLoader = false;
              });
          } catch (error) {
            console.log("err", error);
            if (
              error.message ==
              "VerifyAuthChallengeResponse failed with error Incorrect OTP!!."
            ) {
              this.IsOTPEnabled = false;
              this.loginLoader = false;
              this.SnackbarComponent = {
                SnackbarVmodel: true,
                SnackbarColor: "redColorVariant3",
                timeout: 2000,
                SnackbarText: "Incorrect OTP",
              };
            }
          }
          break;
        case "RESEND_OTP":
          try {
            this.user = await signIn({
              username: this.Login.email_id.toLocaleLowerCase(),
              options: {
                authFlowType: "CUSTOM_WITHOUT_SRP",
              },
            });
            if (
              this.user.nextStep.signInStep ==
              "CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE"
            ) {
              this.SnackbarComponent = {
                SnackbarVmodel: true,
                SnackbarColor: "green",
                timeout: 2000,
                SnackbarText: `Verification OTP sent to ${this.Login.email_id.toLocaleLowerCase()}`,
              };

              this.counter = 60;

              // this.$refs.autoFocusOtpField.reset();
              setTimeout(() => {
                this.IsOTPEnabled = true;
                this.loginLoader = false;
                // setTimeout(() => {
                //   this.$refs.autoFocusOtpField.focus();
                // }, 100);
              }, 1000);
              this.startCountdown();

              this.$forceUpdate();
              // this.startCounter();
            }
          } catch (error) {
            console.log("erro", error);
            if (error.message == "There is already a signed in user.") {
              this.loginLoader = true;
              await signOut({ global: true });
              this.signInMethod("SEND_OTP");
            } else {
              this.loginLoader = false;
              this.SnackbarComponent = {
                SnackbarVmodel: true,
                SnackbarColor: "redColorVariant3",
                timeout: 2000,
                SnackbarText: error.message,
              };
            }
          }
          break;
      }
    },
    changeEmailID() {
      this.Login.email_id = "";
      this.IsOTPEnabled = false;
      this.ResendOTPValue = false;
    },
    ActivateMethod() {
      sessionStorage.setItem("user_email_id", this.Login.email_id);
      setTimeout(() => {
        this.$router.push("/LandingPage");
      }, 1000);
    },
    startCountdown() {
      this.ResendOTPValue = true;
      this.showResendButton = false;
      this.countdown = 45;

      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(this.timer);
          this.ResendOTPValue = false;
          this.showResendButton = true;
        }
      }, 1000);
    },
    resendOTP() {
      this.signInMethod("RESEND_OTP");
    },
  },
};
</script>

<style>
.container {
  display: flex;
  height: 100vh;
}

.wave-container {
  width: 100%; /* Set wave container to 60% of the screen width */
  background: linear-gradient(135deg, #0093e9 0%, #80d0c7 100%);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  overflow: hidden;
  background-image: url("@/assets/bg1.png");
}

.wave-container::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #ffffff;
  clip-path: ellipse(50% 100% at 40% 50%); /* Adjusted for left alignment */
  z-index: 1;
}

.wave-content {
  position: relative;
  z-index: 2;
  text-align: center;
  padding: 20px;
}
.CardColor {
  background: linear-gradient(135deg, #3cabeb 0%, #80d0c7 100%);
}
.containerColor {
  min-height: 100vh;
  background: linear-gradient(135deg, #3cabeb 0%, #80d0c7 100%);
}
.CardStyless {
  background-color: #dde8fe;
  border-radius: 40px;
}
.ImgTransition {
  animation: zoomInOut 4s ease-in-out infinite;
}

@keyframes zoomInOut {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}
</style>
